import * as c_config from "./config.client";

const { api, event } = c_config.__urls__;
var urls = {
    auth: __AUTH_ROOT__,
    api,
    event,
    image: __IMAGE_ROOT__
};
export const __urls__=urls;

export const config = {
    urls
} 


// WEBPACK FOOTER //
// ./src/config.ts